import { Navigate, useLocation } from 'react-router-dom';

type LegacyPrefixRedirectProps = { from: string; to: string };

// Sends an old module URL to its new home: swaps the `from` prefix for `to`, keeping the rest of
// the path and the query string.
export const LegacyPrefixRedirect = ({ from, to }: LegacyPrefixRedirectProps) => {
  const { pathname, search } = useLocation();

  return <Navigate to={`${to}${pathname.slice(from.length)}${search}`} replace />;
};
